import { PageApiKeysEdit } from './Edit';
import { PageApiKeys } from './Overview';

export const APIKEYS = {
  ApiKeys: PageApiKeys,
  ApiKeysEdit: PageApiKeysEdit,
} as const;
